export function Score({ value }: { value: number | null }) {
  return <strong className="execution-score">{value == null ? '—' : value.toFixed(2)}</strong>
}
